import React from 'react';
import { LeadForm } from '../components/LeadForm';
import { SocialProofBar } from '../components/SocialProofBar';
import { TrustBadges } from '../components/TrustBadges';
export function FreeTrial() {
  return <div className="min-h-screen bg-off-white pt-12 pb-24" data-id="element-510">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-511">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-512">
          <div data-id="element-513">
            <div className="mb-8" data-id="element-514">
              <SocialProofBar data-id="element-515" />
            </div>
            <h1 className="text-5xl md:text-6xl text-ink mb-6" data-id="element-516">
              Start Taekwondo in Farmington Hills With One Week Free
            </h1>
            <p className="text-xl text-gray-warm mb-8 leading-relaxed" data-id="element-517">
              Build confidence, focus, discipline, fitness and self-defense
              skills in a structured, family-friendly Taekwondo program led by
              experienced Storm coaches.
            </p>
            <div className="mb-8" data-id="element-518">
              <TrustBadges data-id="element-519" />
            </div>
            <div className="bg-paper p-8 rounded-2xl shadow-sm border border-subtle-gray" data-id="element-520">
              <h3 className="text-2xl text-ink mb-4" data-id="element-521">What Happens Next?</h3>
              <ol className="flex flex-col gap-4 text-gray-warm" data-id="element-522">
                <li className="flex gap-3" data-id="element-523">
                  <span className="font-display text-storm-red text-xl" data-id="element-524">
                    1.
                  </span>
                  <span data-id="element-525">Submit the short form to claim your spot.</span>
                </li>
                <li className="flex gap-3" data-id="element-526">
                  <span className="font-display text-storm-red text-xl" data-id="element-527">
                    2.
                  </span>
                  <span data-id="element-528">
                    Storm will contact you to confirm the best class time.
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-529">
                  <span className="font-display text-storm-red text-xl" data-id="element-530">
                    3.
                  </span>
                  <span data-id="element-531">
                    Attend your first class in comfortable athletic clothes.
                  </span>
                </li>
              </ol>
            </div>
          </div>

          <div className="lg:pl-10" data-id="element-532">
            <div className="bg-ink p-1 rounded-3xl shadow-2xl" data-id="element-533">
              <div className="bg-paper rounded-[22px] p-2" data-id="element-534">
                <div className="bg-subtle-gray/30 rounded-xl p-6 md:p-8" data-id="element-535">
                  <h2 className="text-3xl text-ink text-center mb-2" data-id="element-536">
                    Claim Your Free Week
                  </h2>
                  <p className="text-center text-gray-warm mb-8" data-id="element-537">
                    No experience needed. Ages 3 and up.
                  </p>
                  <LeadForm data-id="element-538" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}